import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { PhrasesService } from '../phrases.service';
import { DictionaryElement } from '../user-defined-phrases/user-defined-phrases.component';

@Component({
  selector: 'app-procedurephrase',
  templateUrl: './procedurephrase.component.html',
  styleUrls: ['./procedurephrase.component.css']
})
export class ProcedurephraseComponent implements OnInit {

  dictionary: Array<DictionaryElement>;
  company_id: any;
  @Input() note: any;
  currentUser: any;

  constructor(
    private phrasesService: PhrasesService,
    private route: ActivatedRoute,
    private authService: AuthService
  ) {
    this.currentUser = this.authService.currentUser;
  }
  async ngOnInit(): Promise<void> {

    if (window.location.pathname.includes('company')) {
      this.company_id = this.route.parent.snapshot.params.id;
    }
    else {
      // this.company_id = '';
      this.company_id = this.currentUser.company_id;
    }


    await this.phrasesService.getProcedurePhrases_old('', { patient_id: this.note.patient?._id }).subscribe((res: any) => {

      this.dictionary = res.data.array;
      console.log("data :  result, ", res.data.array);

    })

    if (this.dictionary?.length > 0) {
      this.sortPhrases(this.dictionary);
    }
  }


  getMarker() {
    return this.phrasesService.marker
  }
  sortPhrases(arr: any[]) {
    arr.sort((a, b) => a.key.toLowerCase().localeCompare(b.key.toLowerCase()));
  }
}

